// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/codebuild/output/src694322608/src/pedro-site/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/codebuild/output/src694322608/src/pedro-site/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/codebuild/output/src694322608/src/pedro-site/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/codebuild/output/src694322608/src/pedro-site/.cache/json/404.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/codebuild/output/src694322608/src/pedro-site/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/codebuild/output/src694322608/src/pedro-site/.cache/json/index.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/codebuild/output/src694322608/src/pedro-site/.cache/json/layout-index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/codebuild/output/src694322608/src/pedro-site/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/codebuild/output/src694322608/src/pedro-site/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js